<template>
  <div id="app">
    <router-view />
    <!-- Avisos del panel (éxito / error) -->
    <db-toaster />
  </div>
</template>

<script>
import DbToaster from "@/components/dashboard/DbToaster.vue";

export default {
  name: "App",
  components: { DbToaster },
};
</script>

<style>
@import "./assets/styles/principal.css";
@import "./assets/styles/site-ui.css";
@import "./assets/styles/dashboard-ui.css";

.row {
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.cabecera {
  position: fixed;
}

.body {
  z-index: 2;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

#webSite {
  animation: fadein 2s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
